// useFetchInvitations.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchInvitations = () => {
    const [invitations, setInvitations] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const populateInvitationsData = async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE
                    },
                });
                const response = await fetch(`${apiUrl}/api/invitations`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setInvitations(data);
                    setLoading(false);
                } else {
                    console.error('Failed to fetch invitations:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching invitations:', error.message);
            }
        };
        populateInvitationsData();
    }, [getAccessTokenSilently]);

    return { invitations, loading };
};
